module.exports = __webpack_public_path__ + "img/marketing-grid-tile.6a397430.jpg";